export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage',
    'Salutation'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'Location'
    ],
    'consulting': [
      'Company',
      'RequestTopic',
      'Location'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic',
      'Location'
    ],
    'offersInvestment': [
      'Company',
      'RequestTopic',
      'Location'
    ],
    'other': [
      'Location'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'Location'
    ],
    'customer_serviceBank': [
      'Company',
      'RequestTopic',
      'Location'
    ],
    'investor_relations': [
      'Company',
      'RequestTopic',
      'Location'
    ],
    'cooperation': [
      'Company',
      'RequestTopic',
      'Location'
    ]
  }
}
